package com.exura.components.icons

import androidx.compose.runtime.Composable
import com.exura.ui.Assets
import com.exura.ui.IconFamily
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily

@Composable
fun UntiledIcon(
    iconSrc: String? = null,
    modifier: Modifier = Modifier,
) = Icon(
    iconSrc = iconSrc ?: Assets.IconsUntiled.PLACEHOLDER,
    modifier = Modifier.fontFamily(IconFamily.UNTILED_UI).then(modifier)
)
